import styled from 'styled-components';

import {flexColumnCenterVertically} from '~/shared/theme/FlexLayout';
import {flipOnLTR} from '~/shared/theme/flipOnLTR';
import {media} from '~/shared/theme/media';

export const PageHeaderPrimaryBar = styled.div`
  height: 100%;
  ${flexColumnCenterVertically}
  flex: 1;
  ${flipOnLTR`
    margin-right: 8px;
  `}

  ${media.minLargeMobile`
    ${flipOnLTR`
      margin-right: 16px;
    `}
  `}
`;
